import { render, staticRenderFns } from "./ChinaASEANInfoCountry.vue?vue&type=template&id=07df25b0&scoped=true"
import script from "./ChinaASEANInfoCountry.vue?vue&type=script&lang=js"
export * from "./ChinaASEANInfoCountry.vue?vue&type=script&lang=js"
import style0 from "./ChinaASEANInfoCountry.vue?vue&type=style&index=0&id=07df25b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07df25b0",
  null
  
)

export default component.exports